
export default {
  name: 'DevDebug',

  props: {
    value: {
      type: [Number, String, Array, Object, Boolean, Date],
      default: null
    },

    title: {
      type: String,
      default: null
    },

    limitedHeight: {
      type: Boolean,
      default: true
    },

    forceShow: {
      type: Boolean,
      default: false
    }
  }
}
